import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { profileEntries } from "@/lib/profiles";

export const SITE = process.env.REACT_APP_SITE_URL;
const BASE_TITLE = "The Groove Anomaly records | Musica elettronica, House e Techno – Etichetta indipendente";
const TITLES = { "/uscite": "Uscite", "/artisti": "Artisti", "/chi-siamo": "Chi siamo", "/contatti": "Contatti" };

const setAttr = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

// Injects Organization JSON-LD with every label profile so search engines link all platforms together.
export const LabelJsonLd = () => {
  const { settings } = useSettings();
  useEffect(() => {
    const sameAs = [settings.instagram, settings.facebook, ...profileEntries(settings).map((p) => p.url)]
      .filter((u) => u && u.startsWith("https://") && !u.includes("/search"));
    let el = document.getElementById("tga-label-jsonld");
    if (!el) { el = document.createElement("script"); el.type = "application/ld+json"; el.id = "tga-label-jsonld"; document.head.appendChild(el); }
    el.textContent = JSON.stringify({
      "@context": "https://schema.org", "@type": ["Organization", "MusicGroup"], "@id": `${SITE}/#organization`,
      name: "The Groove Anomaly records", url: `${SITE}/`, logo: `${SITE}/og-image.jpg`, sameAs,
    });
    [["google-site-verification", settings.google_verification], ["msvalidate.01", settings.bing_verification]].forEach(([name, val]) => {
      let m = document.querySelector(`meta[name="${name}"]`);
      if (!val) return m?.remove();
      if (!m) { m = document.createElement("meta"); m.name = name; document.head.appendChild(m); }
      m.setAttribute("content", val);
    });
  }, [settings]);
  return null;
};

export const NoIndex = ({ children }) => {
  useEffect(() => {
    const el = document.querySelector('meta[name="robots"]');
    const prev = el?.getAttribute("content");
    el?.setAttribute("content", "noindex, nofollow");
    return () => { if (el && prev) el.setAttribute("content", prev); };
  }, []);
  return children;
};

export const SeoRoute = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const url = `${SITE}${pathname === "/" ? "/" : pathname}`;
    const page = TITLES[pathname];
    if (page || pathname === "/") document.title = page ? `${page} | The Groove Anomaly` : BASE_TITLE;
    setAttr('meta[property="og:title"]', "content", document.title);
    setAttr('link[rel="canonical"]', "href", url);
    setAttr('meta[property="og:url"]', "content", url);
  }, [pathname]);
  return null;
};
